import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import categoryService from '../services/categoryService';
import creditCardService from '../services/creditCardService';

const AppContext = createContext();

export const useAppContext = () => {
  const context = useContext(AppContext);
  if (!context) {
    throw new Error('useAppContext must be used within an AppProvider');
  }
  return context;
};

export const AppProvider = ({ children }) => {
  const [categories, setCategories] = useState([]);
  const [creditCards, setCreditCards] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadCategories = useCallback(async () => {
    try {
      const data = await categoryService.getAll();
      setCategories(data);
    } catch (error) {
      console.error('Erro ao carregar categorias:', error);
    }
  }, []);

  const loadCreditCards = useCallback(async () => {
    try {
      const data = await creditCardService.getAll();
      setCreditCards(data);
    } catch (error) {
      console.error('Erro ao carregar cartões:', error);
    }
  }, []);

  const refreshData = useCallback(async () => {
    setLoading(true);
    await Promise.all([loadCategories(), loadCreditCards()]);
    setLoading(false);
  }, [loadCategories, loadCreditCards]);

  useEffect(() => {
    refreshData();
  }, [refreshData]);

  const value = {
    categories,
    creditCards,
    loading,
    refreshData,
    setCategories,
    setCreditCards
  };

  return (
    <AppContext.Provider value={value}>
      {children}
    </AppContext.Provider>
  );
}; 